import { reactive } from 'vue'

export const NotificationStore = reactive({
    show: false,
    message: '',
    color: 'error',
    timeout: 4000,

    success(message) {
        this.message = message;
        this.color = 'success';
        this.timeout = 3000;
        this.show = true;
    },

    error(message) {
        this.message = message || 'Something went wrong. Please try again.';
        this.color = 'error';
        this.timeout = 5000;
        this.show = true;
    },

    info(message) {
        this.message = message;
        this.color = 'info';
        this.timeout = 3000;
        this.show = true;
    },

    warn(message) {
        this.message = message;
        this.color = 'warning';
        this.timeout = 4000;
        this.show = true;
    }
});
